// extracted by mini-css-extract-plugin
module.exports = {"Quote":"BlockQuote_Quote__18u5L"};